import React from "react";
import type { IntegrationAuditDto } from "@/api/integrations";
import JsonViewer from "@/ui-controls/JsonViewer";

interface Props {
  audit: IntegrationAuditDto;
  onClose?: () => void;
}

const AuditDetailsPanel = (props: Props) => {
  const parsePayload = () => {
    try {
      return JSON.parse(props.audit.operationPayload);
    } catch {
      return props.audit.operationPayload;
    }
  };

  return <JsonViewer object={parsePayload()} />;
};

export default AuditDetailsPanel;
